import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { FileInfoType, fileUploadValidator } from '@schoolbelle/api/file';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-file-row',
  templateUrl: './file-row.component.html',
  styleUrls: ['./file-row.component.css']
})
export class LetterWriteFileListFileRowComponent implements OnInit {
  @Input('index') i:number;
  @Input() file:File|FileInfoType;
  @Input() showMimeType:boolean;
  @Output() onRemove = new EventEmitter(); 
  control:FormControl;
  constructor() {}

  ngOnInit() {
    this.control = new FormControl(this.file, fileUploadValidator);
  }
  remove () {
    this.onRemove.next(null);
  }

}
